import { MARK } from './mark.js';

// `pill` picks the header's privacy indicator. The default states the comparison
// guarantee in its strongest form. On a page that DOES send something — /pro's
// interest form — that wording would be read as "this page sends nothing", so the
// pill narrows to the claim that is still exactly true: the comparison files stay
// here. The claim itself never weakens; only its scope is made explicit.
const PILLS = {
  default: {
    title: 'All comparison happens in this tab. Click for how it works.',
    html: '<b>0 bytes uploaded</b><span class="long"> · works offline</span>',
  },
  local: {
    title: 'Your comparison files never leave this tab. The form on this page sends only what you type into it.',
    html: '<b>comparison files stay local</b>',
  },
};

// `current` marks the nav item for the page being viewed — aria-current for
// assistive tech, amber for everyone else. Passing nothing leaves the bar as it
// was, which is what the app page wants (its nav has no entry for itself).
const NAV = [
  { key: 'formats', href: '/go/', label: 'Formats' },
  { key: 'viewer', href: '/parquet-viewer.html', label: 'Parquet viewer' },
  { key: 'pro', href: '/pro.html', label: 'Pro' },
];

export function header({ pill = 'default', current = null } = {}) {
  const { title, html } = PILLS[pill] || PILLS.default;
  const nav = NAV.map(
    (n) => `<a href="${n.href}"${n.key === current ? ' aria-current="page"' : ''}>${n.label}</a>`,
  ).join('\n        ');
  return `
  <header>
    <div class="wrap bar">
      <a class="logo" href="/" aria-label="cruxdiff home"><span class="mark">${MARK}</span> cruxdiff</a>
      <!-- Formats is live (the /go/ landing pages — the internal-linking spine that
           makes them crawlable). Pro now has a destination: an interest page, not a
           paid plan. CLI & API stays hidden until it has one:
           <a href="/cli">CLI &amp; API</a> -->
      <nav aria-label="Primary">
        ${nav}
      </nav>
      <div class="spacer"></div>
      <a class="privacy-pill" href="/privacy.html" title="${title}">
        <span class="dot"></span><span>${html}</span>
      </a>
    </div>
  </header>`;
}
